import { EventEmitter } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { merge, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { KeysOfType } from '../utility-functions';

export class MatDialogHelper {
  private constructor() {}

  static getClosedObservable<C, R>(
    matDialogRef: MatDialogRef<C>,
    eventEmitterKey: KeysOfType<C, EventEmitter<R>>
  ): Observable<R | void> {
    const eventEmitter = (<unknown>(
      matDialogRef.componentInstance[eventEmitterKey]
    )) as EventEmitter<R>;
    return merge(matDialogRef.afterClosed(), eventEmitter).pipe(take(1));
  }
}
